import React from 'react';

const TickIcon = ({
  width = 24,
  height = 24,
  fill = '#A2B2C4',
  className = '',
  viewBox = '0 0 24 24',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      className={className}
      {...props}
    >
      <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1.293 14.707l-4-4 1.414-1.414L10.707 14l6.586-6.586 1.414 1.414-8 8z" />
    </svg>
  );
};

export default TickIcon;
